import AppCatalog from "../../services/App/AppCatalog.js";
import AppModule from "../../services/App/AppModule.js";
import InputType from "../../services/Input/InputType.js";
import OutputType from "../../services/Input/OutputType.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  DispatchID: {
    Label: AppModule.Item.FullName,
    ColumnLabel: AppCatalog.Field.Name.Label,
    ExportLabel: AppCatalog.Field.Name.Label,
    PrintLabel: AppCatalog.Field.Name.Label,
    Type: AppCatalog.Field.ID.Type,
    Required: true,
    RelatedValue: "Name",
    RelatedModule: AppModule.Item,
    RelatedIsActive: "DispatchIsActive"
  },
  HppTotal: {
    Label: AppCatalog.Field.HppTotal.Label,
    Type: AppCatalog.Field.HppTotal.Type,
    Output: AppCatalog.Field.HppTotal.Output,
    ReadOnly: AppCatalog.Field.HppTotal.ReadOnly
  },
  Name: {
    Label: AppCatalog.Field.Name.Label,
    Type: AppCatalog.Field.Name.Type,
    MaxLength: 255,
    Required: true
  },
  PackagingName: {
    Label: AppModule.ItemPackaging.FullName,
    Type: AppCatalog.Field.Name.Type,
    Input: AppCatalog.Field.ID.Input,
    Required: true
  },
  Price: {
    Label: AppCatalog.Field.SubTotal.Label,
    Type: AppCatalog.Field.SubTotal.Type,
    ReadOnly: AppCatalog.Field.SubTotal.ReadOnly,
    Output: AppCatalog.Field.SubTotal.Output
  },
  RequestedQuantity: {
    Label: AppCatalog.Field.Qty.Label,
    SummaryLabel: AppCatalog.Field.Qty.Label + " Penjualan",
    Type: AppCatalog.Field.Qty.Type,
    MinValue: AppCatalog.Field.Qty.MinValue,
    MaxLength: AppCatalog.Field.Qty.MaxLength,
    Required: true
  },
  SellPrice: {
    Label: AppCatalog.Field.SellPrice.Label,
    Type: AppCatalog.Field.SellPrice.Type,
    MinValue: AppCatalog.Field.SellPrice.MinValue,
    MaxLength: AppCatalog.Field.SellPrice.MaxLength,
    Output: AppCatalog.Field.SellPrice.Output,
    Required: true
  },
  DiscType: {
    Label: "Tipe Diskon",
    Type: AppCatalog.Field.DiscType.Type
  },
  DiscPercent: {
    Label: AppCatalog.Field.DiscPercent.Label,
    Type: AppCatalog.Field.DiscPercent.Type,
    MinValue: AppCatalog.Field.DiscPercent.MinValue,
    MaxValue: AppCatalog.Field.DiscPercent.MaxValue
  },
  DiscValue: {
    Label: AppCatalog.Field.DiscValue.Label,
    Type: AppCatalog.Field.DiscValue.Type,
    MinValue: AppCatalog.Field.DiscValue.MinValue,
    MaxLength: AppCatalog.Field.DiscValue.MaxLength,
    Output: AppCatalog.Field.DiscValue.Output
  },
  ItemDiscValue: {
    Label: "Nilai Diskon"
  },
  ItemDisc: {
    Label: "Diskon Barang",
    Type: AppCatalog.Field.TotalDisc.Type,
    ReadOnly: AppCatalog.Field.TotalDisc.ReadOnly,
    Output: AppCatalog.Field.TotalDisc.Output
  },
  TotalAfterDisc: {
    Label: "Sub Total",
    Type: AppCatalog.Field.SubTotal.Type,
    ReadOnly: AppCatalog.Field.SubTotal.ReadOnly,
    Output: AppCatalog.Field.SubTotal.Output
  },
  TotalItemDisc: {
    Label: "Total Diskon Barang",
    Type: AppCatalog.Field.TotalDisc.Type,
    ReadOnly: AppCatalog.Field.TotalDisc.ReadOnly,
    Output: AppCatalog.Field.TotalDisc.Output
  },
  SpecialPriceDiscPercent: {
    Label:AppCatalog.Field.DiscPercent.ExportLabel + " " +
      AppModule.SpecialPrice.FullName,
    Type: AppCatalog.Field.DiscPercent.Type,
  },
  SpecialPriceID: {
    Label: AppModule.SpecialPrice.FullName,
    ExportLabel: AppCatalog.Field.Name.Label + " " + AppModule.SpecialPrice.FullName,
    Type: AppCatalog.Field.ID.Type,
    Input: AppCatalog.Field.ID.Input,
    RelatedValue: "SpecialPriceName",
    RelatedModule: AppModule.SpecialPrice,
    RelatedIsActive: "SpecialPriceIsActive",
    NullText: AppCatalog.Message.Without + " " + AppModule.SpecialPrice.FullName
  },
  TotalRequestedQuantity: {
    Label: AppCatalog.Field.TotalQty.Label,
    Type: AppCatalog.Field.TotalQty.Type,
    ReadOnly: AppCatalog.Field.TotalQty.ReadOnly
  },

  // support
  BasicTotalPrice: {
    Label: AppCatalog.Field.Total.Label + " Harga",
    Type: AppCatalog.Field.Total.Type,
    Output: AppCatalog.Field.Total.Output,
    ReadOnly: AppCatalog.Field.Total.ReadOnly
  },
  DeliveryQuantity: {
    Label: AppCatalog.Field.Qty.Label + " Pengiriman",
    Type: AppCatalog.Field.Qty.Type,
    ReadOnly: true
  },
  DiscountedValue: {
    Label: "HEMAT",
    Type: InputType.Integer,
    Output: OutputType.Integer.Currency
  },
  DispatchImageSrc: {
    Label: AppCatalog.Field.ImageSrc.Label,
    Type: AppCatalog.Field.ImageSrc.Type,
    ReadOnly: true
  },
  DispatchSellPrice: {
    Label: AppCatalog.Field.DispatchSellPrice.Label,
    Type: AppCatalog.Field.DispatchSellPrice.Type,
    ReadOnly: AppCatalog.Field.DispatchSellPrice.ReadOnly,
    Output: AppCatalog.Field.DispatchSellPrice.Output
  },
  Packaging: {
    Label: AppModule.ItemPackaging.FullName,
    Type: AppCatalog.Field.Name.Type,
    ReadOnly: true
  },
  ParentDisc: {
    Label: AppCatalog.Field.Disc.Label + " Penjualan",
    Type: AppCatalog.Field.Total.Type,
    Output: AppCatalog.Field.Total.Output,
    ReadOnly: AppCatalog.Field.Total.ReadOnly
  },
  Profit: {
    Label: AppCatalog.Field.Profit.Label,
    Type: AppCatalog.Field.Profit.Type,
    Output: AppCatalog.Field.Profit.Output,
    ReadOnly: AppCatalog.Field.Profit.ReadOnly
  },
  ProfitMargin: {
    Label: AppCatalog.Field.ProfitMargin.Label,
    Type: AppCatalog.Field.ProfitMargin.Type,
    ReadOnly: AppCatalog.Field.ProfitMargin.ReadOnly
  },
  QtyAvailable: {
    Label: AppCatalog.Field.Qty.Label + " Jual",
    Type: AppCatalog.Field.Qty.Type,
    ReadOnly: true
  },
  SalesDraftItemQty: {
    Label: AppCatalog.Field.Qty.Label + " SO",
    Type: AppCatalog.Field.Qty.Type,
    ReadOnly: true
  },
  SKU: {
    Label: AppCatalog.Field.SKU.Label,
    Type: AppCatalog.Field.SKU.Type,
    ReadOnly: true
  },
  SpecialPriceStock: {
    Label: AppCatalog.Field.Stock.Label + " " + AppModule.SpecialPrice.FullName,
    Type: AppCatalog.Field.Stock.Type,
    ReadOnly: AppCatalog.Field.Stock.ReadOnly
  },
  Stock: {
    Label: AppCatalog.Field.Stock.Label,
    Type: AppCatalog.Field.Stock.Type,
    ReadOnly: AppCatalog.Field.Stock.ReadOnly
  }
}